import styled from "styled-components";

import documentSVG from "../../assets/document.svg";
import DownloadIcon from "../../assets/download-icon.svg";
import { useRef, useState, useEffect } from "react";
import General from "../../stores/GeneralStore";
import generalStore from "../../stores/GeneralStore";
import constants from "../../utils/constants";
import { NotifyError } from "../..//utils/ShowError";
import { SpinnerRaw } from "../SpinnerRaw/SpinnerRaw";

//************************************************************

const DocumentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
  background: rgba(229, 239, 242, 0.7);
  border: 1px solid rgba(16, 30, 142, 0.257309);
  height: 60px;
`;
//margin-bottom: 10px;

//border: 1px solid ${props => props.exists ? "black" : "orange"} ;
interface Props {
  flex: boolean;
}
const DocumentLeading = styled.img`
  align-items: start;
  justify-content: start;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const DocumentTextWrapper = styled.div<Props>`
  flex: ${(flex) => (flex ? 6 : 3)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  align-self: start;
  margin-top: auto;
  margin-bottom: auto;
`;

const DocumentMainText = styled.div`
  font-size: 13px;
  font-weight: 700;
  font-family: "Segoe UI";
  align-self: start;
`;

const DocumentSubText = styled.div`
  font-size: 14px;
  align-self: start;
`;

const DocumentName = styled.div`
  flex: 3;
  font-size: 12px;
  align-items: center;
  margin: auto;
`;

const DocumentTrailing = styled.div`
  display: flex;
  flex-direction: row;
  width: 25%;
  justify-content: center;
  align-items: center;
  color: #101e8e;
`;

// const DocumentFileButtonOLD = styled.input.attrs({
//     type: 'file'
//   })`
// color: transparent;
//   :-webkit-file-upload-button {
//     visibility: hidden;
//   }

//   &:before{
//     content: 'Choose File';
//     display: inline-block;
//     background: -webkit-linear-gradient(top, #f9f9f9, #e3e3e3);
//     background: linear-gradient(top, #f9f9f9, #e3e3e3);
//     border: 1px solid #999;
//     border-radius: 3px;
//     padding: 5px 8px;
//     outline: none;
//     white-space: nowrap;
//     -webkit-user-select: none;
//     cursor: pointer;
//   }
// `;

const DocumentFileButton = styled.input.attrs({
  type: "file",
  
})`
  display: none;
`;

const DocumentButton = styled.button`
  box-sizing: border-box;
  color: #101e8e;
  background-color: #fff;
  border: 1px solid #101e8e;
  width: 144px;
  min-height: 46px;
  margin-right: 10px;
  font-weight: 700;
`;

const DocumentSize = styled.span`
  font-size: 16px;
  align-self: start;
`;

export const Document = ({
  exists,
  mainText,
  subText,
  name,
  size,
  inputName,
  onChange,
  downloadClick,
  loader,
  index,
  loaderIndex,
  label,
  removeButton,
  moveout,
  dispute,
  acceptFileType = "application/pdf",
}: {
  exists: Boolean;
  mainText: string;
  subText: string;
  name?: String | undefined;
  size?: String | undefined | Number;
  inputName: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  downloadClick?: any;
  loader?: any;
  index?: any;
  label?: any;
  loaderIndex?: any;
  removeButton?: any;
    moveout?: boolean;
    dispute?: boolean;
    acceptFileType ?: any;
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [documentName, setDocumentName] = useState<string | null>(null);
  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files![0];

    if (!selectedFile) {
      return;
    }


    if (!constants?.allowedFileTypes?.includes(selectedFile.type)) {
      const errorMessage = "Invalid file type. Please select a PNG, JPG, JPEG, or PDF file.";
      NotifyError(errorMessage);
      return;
    }

    const maxSize = moveout||dispute ? 2 * 1024 * 1024 : 10 * 1024 * 1024; // 2 MB or 10 MB in bytes
    if (selectedFile.size > maxSize) {
     const errorMessage = moveout ? "Please upload file that have less than 2 MB" : General?.codeLabels["cm_file_upload_er"]?.label ? General?.codeLabels["cm_file_upload_er"]?.label : "Please upload file that have less than 10 MB";
      NotifyError(errorMessage);
      return;
    }

    // File type and size are valid, set the document name and trigger the onChange function
    setDocumentName(label ? `${label}-${selectedFile.name}` : selectedFile.name);
    onChange!(e);
  };

  const ColorAss = generalStore?.ColorAss;
  const contrast = generalStore?.contrast;

  return (
    <DocumentWrapper
      style={{
        gap: "0rem",
        margin: "10px 0px",
        background: General.contrast.contrastColor ? General.contrast.contrastColor : contrast?.contrastBackground
      }}
    >
      <DocumentLeading src={documentSVG} />

      <DocumentTextWrapper flex={name ? false : true}>
        <DocumentMainText style={{
          color: General.contrast.contrastBackground ? General.contrast.contrastBackground : General?.ColorAss,
        }}>
          {mainText}
        </DocumentMainText>
        <DocumentSubText style={{
          color: General.contrast.contrastBackground ? General.contrast.contrastBackground : General?.ColorAss,
        }}>
          {subText}
        </DocumentSubText>
      </DocumentTextWrapper>

      {name || documentName ? (
<DocumentName
          style={{
            color: General.contrast.contrastBackground ? General.contrast.contrastBackground : General?.ColorAss,
            background: General.contrast.contrastColor ? General.contrast.contrastColor : contrast?.contrastBackground,
            marginRight:moveout? "-150px": dispute ? "-40px" : "0px",
          }}
        >
          {name ? name?.length > 17 ? `${name?.slice(0, 17)}...` : name : documentName && documentName?.length > 17 ? `${documentName?.slice(0, 17)}...` : documentName}
        </DocumentName>
      ) : null}
      <DocumentTrailing
        style={{
          justifyContent: "space-around",
        }}
      >
        {exists ? (
          <>
            {size !== undefined && (
              <>
                <DocumentSize>
                  {(parseInt(size?.toString()) / 1024).toFixed(2) + " Kb"}
                </DocumentSize>
                {index == loaderIndex && loader ? <SpinnerRaw width={20} height={20} /> : <img style={{ cursor: 'pointer' }} onClick={() => downloadClick(name, index)} src={DownloadIcon} />}
              </>
            )}
          </>
        ) : (
          <>
            <DocumentFileButton
              ref={inputRef}
              name={inputName}
                onChange={handleChange}
                accept={acceptFileType}
            />
            <DocumentButton
              style={{
                width: General?.isLargeScreen ? "8vw" : "30vw",
                height: "36px",
                zIndex: "0",
                fontSize: General?.isLargeScreen ? `${General.accessibility.fontSize}rem` : `${0.7 * General.accessibility.fontSize}rem`,
                background: General.contrast.contrastBackground ? General.contrast.contrastBackground : "#fff",
                color: General.contrast.contrastBackground ? General.contrast.contrastColor : General?.ColorAss,
                borderColor:General.contrast.contrastBackground ? General.contrast.contrastColor : General?.ColorAss,
              }}
              onClick={handleClick}
              type="button"
            >
              {General?.codeLabels["cm_choosefile"]?.label !== undefined
                ? General?.codeLabels["cm_choosefile"]?.label
                : "CHOOSE FILE"}
              </DocumentButton>
              {removeButton && (
              <div
                  style={{
                backgroundColor:"red",
                display: "flex",
                alignItems: "flex-end",
                // justifyContent: "space-between",
                // border: "1px solid #ccc",
                padding:0,
               
                background: "#f8f8f8",
                width: "15%",
              }}
              >
              {removeButton}
              </div>
            )}
          </>
        )}
      </DocumentTrailing>
    </DocumentWrapper>
  );
};

export const DocumentList = ({ list }: { list: Object[] }) => { };
